var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _ro, _settleId, _dk, _mb, _wrapper, _target, _onBreakpoint, _update, _JumboText_instances, listen_fn, getLines_fn;
import { l as lazyInit, I as findOptimalFontSize } from "./utilities-Da0sjanJ.js";
const _mq = matchMedia("(max-width: 991px)");
class JumboText extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _JumboText_instances);
    __privateAdd(this, _ro);
    __privateAdd(this, _settleId, null);
    __privateAdd(this, _dk, null);
    // { width, height, fontSize }
    __privateAdd(this, _mb, null);
    // { width, height, fontSize }
    __privateAdd(this, _wrapper);
    // cached closest('jumbo-text-component')
    __privateAdd(this, _target);
    __privateAdd(this, _onBreakpoint, () => {
      clearTimeout(__privateGet(this, _settleId));
      __privateSet(this, _settleId, setTimeout(() => __privateGet(this, _update).call(this, true, "BreakpointChange"), 50));
    });
    __privateAdd(this, _update, (force = false, trigger = "Unknown") => {
      if (window.__isResizing) return;
      requestAnimationFrame(() => {
        const wrapper = __privateGet(this, _wrapper) ?? __privateSet(this, _wrapper, this.closest("jumbo-text-component"));
        const logoHeader = this.closest(".logo-header-v2");
        const logoHeaderItem = this.closest(".logo-header-v2-content-item");
        const target = __privateGet(this, _target) ?? __privateSet(this, _target, wrapper || this);
        const isMb = _mq.matches;
        const cache = isMb ? __privateGet(this, _mb) : __privateGet(this, _dk);
        let currentWidth = wrapper ? wrapper.offsetWidth : this.offsetWidth;
        if (logoHeaderItem) {
          currentWidth = Math.min(currentWidth, logoHeaderItem.offsetWidth);
        }
        if (logoHeader) {
          currentWidth = Math.min(currentWidth, logoHeader.offsetWidth);
        }
        let currentHeight = wrapper ? wrapper.offsetHeight : this.offsetHeight;
        if (logoHeader) currentHeight = logoHeader.offsetHeight;
        const lines = __privateMethod(this, _JumboText_instances, getLines_fn).call(this);
        const style = window.getComputedStyle(this);
        let wrapperMaxHeight, logoHeaderMaxHeight;
        if (wrapper && lines.length > 1) {
          wrapperMaxHeight = parseFloat(window.getComputedStyle(wrapper).maxHeight);
        } else if (logoHeader) {
          logoHeaderMaxHeight = parseFloat(window.getComputedStyle(logoHeader).maxHeight);
        }
        const fontProps = {
          fontStyle: style.fontStyle,
          fontWeight: style.fontWeight,
          fontFamily: style.fontFamily,
          letterSpacing: style.letterSpacing,
          fontSize: style.fontSize,
          lineHeight: style.lineHeight
        };
        if (!force && cache && Math.abs(currentWidth - cache.width) <= 2 && Math.abs(currentHeight - cache.height) <= 2) {
          requestAnimationFrame(() => {
            target.style.setProperty(isMb ? "--jt-fs-mb" : "--jt-fs-dk", `${cache.fontSize}px`);
            this.classList.add("active");
            __privateMethod(this, _JumboText_instances, listen_fn).call(this);
          });
          return;
        }
        if (!currentWidth || !lines.length) {
          requestAnimationFrame(() => {
            this.classList.add("active");
            __privateMethod(this, _JumboText_instances, listen_fn).call(this);
          });
          return;
        }
        const longest = lines.reduce((a, b) => a.length > b.length ? a : b);
        let fontSize = findOptimalFontSize(longest, currentWidth, fontProps);
        if (wrapperMaxHeight) {
          const lh = parseFloat(fontProps.lineHeight) / parseFloat(fontProps.fontSize) || 1;
          const heightBasedSize = wrapperMaxHeight / (lines.length * lh);
          fontSize = Math.min(fontSize, heightBasedSize);
        } else if (logoHeaderMaxHeight) {
          const lh = parseFloat(fontProps.lineHeight) / parseFloat(fontProps.fontSize) || 1;
          const heightBasedSize = logoHeaderMaxHeight / (lines.length * lh);
          fontSize = Math.min(fontSize, heightBasedSize);
        }
        if (isMb) __privateSet(this, _mb, { width: currentWidth, height: currentHeight, fontSize });
        else __privateSet(this, _dk, { width: currentWidth, height: currentHeight, fontSize });
        requestAnimationFrame(() => {
          target.style.removeProperty(isMb ? "--jt-fs-mb" : "--jt-fs-dk");
          target.style.fontSize = "";
          target.style.setProperty(isMb ? "--jt-fs-mb" : "--jt-fs-dk", `${fontSize}px`);
          this.classList.add("active");
          __privateMethod(this, _JumboText_instances, listen_fn).call(this);
        });
      });
    });
  }
  // wrapper || this
  connectedCallback() {
    __privateSet(this, _ro, new ResizeObserver(() => {
      clearTimeout(__privateGet(this, _settleId));
      __privateSet(this, _settleId, setTimeout(() => __privateGet(this, _update).call(this, false, "ResizeObserver"), 150));
    }));
    lazyInit(this, () => {
      setTimeout(() => __privateGet(this, _update).call(this, false, "Initial"), 0);
      document.fonts.ready.then(() => {
        setTimeout(() => __privateGet(this, _update).call(this, true, "FontsReady"), 500);
      });
    });
  }
  disconnectedCallback() {
    var _a;
    (_a = __privateGet(this, _ro)) == null ? void 0 : _a.disconnect();
    clearTimeout(__privateGet(this, _settleId));
    _mq.removeEventListener("change", __privateGet(this, _onBreakpoint));
  }
}
_ro = new WeakMap();
_settleId = new WeakMap();
_dk = new WeakMap();
_mb = new WeakMap();
_wrapper = new WeakMap();
_target = new WeakMap();
_onBreakpoint = new WeakMap();
_update = new WeakMap();
_JumboText_instances = new WeakSet();
listen_fn = function() {
  __privateGet(this, _ro).observe(this);
  const logoHeader = this.closest(".logo-header-v2");
  if (logoHeader) __privateGet(this, _ro).observe(logoHeader);
  const wrapper = this.closest("jumbo-text-component");
  if (wrapper) __privateGet(this, _ro).observe(wrapper);
  _mq.addEventListener("change", __privateGet(this, _onBreakpoint));
};
getLines_fn = function() {
  const lines = [];
  let current = "";
  for (const node of this.childNodes) {
    if (node.nodeName === "BR") {
      const trimmed2 = current.trim();
      if (trimmed2) lines.push(trimmed2);
      current = "";
    } else {
      current += node.textContent || "";
    }
  }
  const trimmed = current.trim();
  if (trimmed) lines.push(trimmed);
  return lines;
};
if (!customElements.get("jumbo-text")) {
  customElements.define("jumbo-text", JumboText);
}
